<template>
	<base-spinner :open="vehicleloading"></base-spinner>
	<base-saved-vehicles :open="openSavedVehicles" @close="closeSavedVehiclesDialog"></base-saved-vehicles>
	<teleport to="body">
		<transition name="backdrop" appear>
			<div class="backdrop" @click="$emit('close')" v-if="open"></div>
		</transition>
		<transition name="modal" appear>
			<div open v-if="open" class="vehicle-modal modal-dialog-centered">
				<dialog @keydown.esc="$emit('close')" class="vehicle-picker-modal__panel vehicle-picker-modal__panel--active">
					<a href="#" class="dialog-close" title="Close" @click.prevent="$emit('close')" >
						<i class="fa fa-close"> </i>
					</a>

					<div class="vehicle-picker-modal__title card-title">
						{{catclass}} Search - Select Vehicle
					</div>
					<base-message v-if="vehiclemessages.length > 0 && !vehicleloading" :servermessages="vehiclemessages"></base-message>
					<div class="vehicle-form vehicle-form--layout--modal">
						<div class="vehicle-form__item vehicle-form__item--select">
							<select class="form-control " aria-label="Year" v-model="selectedyear" @change="getMakes" >
								<option value="0">Select Year</option>
								<option v-for="year in years" :key="year">
									{{ year.year }}
								</option>
							</select>
						</div>
						<div class="vehicle-form__item vehicle-form__item--select" v-if="storeCatalog === 'WHI'">
							<select class="form-control " aria-label="Make" v-model="selectedmake" @change="getModels" :disabled="selectedyear === 0">
								<option value="">Select Make</option>
								<option v-for="make in makes" :key="make.make" :value="make.make">
									{{ make.desc }}
								</option>
							</select>
						</div>
						<div class="vehicle-form__item vehicle-form__item--select" v-if="storeCatalog === 'WHI'">
							<select class="form-control" aria-label="Model" v-model="selectedmodel" @change="getEngines" :disabled="selectedmake === ''">
								<option value="">Select Model</option>
								<option v-for="model in models" :key="model.model" :value="model.model">
									{{ model.desc }}
								</option>
							</select>
						</div>
						<model-autocomplete v-else elemid="baseselectvehicle" :_models="models" @model_selected="plink_model"></model-autocomplete>
						<div class="vehicle-form__item vehicle-form__item--select" v-if="storeCatalog === 'WHI'">
							<select class="form-control " aria-label="Engine"  v-model="selectedengine" :disabled="selectedmodel === ''">
								<option value="">Select Engine</option>
								<option v-for="engine in engines" :key="engine.engine" :value="engine.engine">
									{{ engine.desc }}
								</option>
							</select>
						</div>
						<div class="vehicle-form__divider">Or</div>
						<div class="vehicle-form__item">
							<input type="text" class="form-control" :placeholder="searchstr_placeholder" aria-label="VIN number" v-model="vinnumber" />
							<!-- <table>
							<tbody>
								<tr>
								<td class="p-0">
									<input type="text" class="form-control form-control-search-parts-vin-modal-2" :placeholder="searchstr_placeholder" aria-label="VIN number" v-model="vinnumber" />
								</td>
								</tr>
							</tbody>
							</table> -->
						</div>
					</div>
					<div class="vehicle-picker-modal__actions">
						<button type="button" class="btn btn-sm btn-secondary" data-to-panel="list" @click.prevent="openSavedVehiclesDialog" v-if="userIsAuthenticated">
							View Saved Vehicles
						</button>
						<button class="btn btn-primary btn-sm" @click="searchParts();closeDialog();">Search Parts</button>
					</div>
				</dialog>
			</div>
		</transition>
	</teleport>
</template>

<script>	
import { mapGetters } from 'vuex';
import VehicleSearch from '../../mixins/vehicle_search.js';
import ModelAutocomplete from '../common/vehicle/ModelAutocomplete.vue';

export default {
	components: { "model-autocomplete" : ModelAutocomplete },
    mixins: [VehicleSearch],
	props: {
		open: {
			type: Boolean,
			required: true,
			default: false
		},
	},
	emits: [ 'close' ],
    data() {
        return {
			openSavedVehicles: false
        };
    },
    computed: {
        ...mapGetters([
            'userIsAuthenticated',
			'storeCatalog',
			"appInitialiazed"
        ]),
		...mapGetters('api', [
			"catclass",
		]),
		searchstr_placeholder() {
          if(this.storeCatalog == 'WHI'){
            return 'Enter VIN number';
          }

          return 'Enter OE Number';
        }
    },
	methods: {
		closeDialog(){
			// this.$store.dispatch('vehicle/setSelectedCategories', qtypes);
			// this.$store.dispatch('vehicle/setSelectedGroups', qgroups);
			// const selectedcat = this.$store.getters['vehicle/selectedcategories'];
			// const selectedgroup = this.$store.getters['vehicle/selectedgroups'];

			this.$emit('search_updated');

			this.$emit('close');
		},

		openSavedVehiclesDialog() {
			this.openSavedVehicles = true;
			this.$emit('close');
		},
		
		closeSavedVehiclesDialog() {
			this.openSavedVehicles = false;
		},

		plink_model(pmodel){
          this.selectedmodel = pmodel.model;
          this.selectedmake = pmodel.make;
        }
	},

	watch: {
		vehiclewasselected(newVal) {
			if (newVal) {
				this.$emit('close');
				this.vehiclewasselected = false;
			}
		},
		appInitialiazed(newVal) {
			if(newVal == true){
				this.getYears();
			}
		}
	},
	
	created() {
		this.openSavedVehicles = false;
		this.clearData();
		if(this.appInitialiazed == true){
			this.getYears();
		}
	}
}
</script>

<style scoped>
.vehicle-picker-modal__panel {
	max-width: 500px;
}

.vehicle-modal{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 999;
    width: 100%;
    height: 100%;
	padding: 0.5rem;
}

/* dialog */
.vehicle-picker-modal__panel {
	position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
}

header {
  position: relative;
}

header .card-title {
  min-height: 45px;
}

.dialog-close {
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
}

.dialog-close:before, 
.dialog-close:after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2px;
    height: 15px;
    background-color: #2c3e50;
    transform: rotate(45deg) translate(-50%, -50%);
    transform-origin: top left;
    transition: all 420ms;
    content: '';
}

.dialog-close:after {
    transform: rotate(-45deg) translate(-50%, -50%);
}

.backdrop {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: rgba(51, 51, 51, 0.8);
  opacity: 0.6;
  cursor: pointer;
}

.backdrop-enter-active {
  animation: backdrop ease .4s;
}

.backdrop-leave-active {
  animation: backdrop ease .4s reverse;
}

@keyframes backdrop {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.6;
  }
}

.modal-enter-active {
  animation: modal 0.3s ease-out;
}

.modal-leave-active {
  animation: modal 0.3s ease-in reverse;
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.actions {
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  margin-top: 2rem;
  text-align: right;
}

[dir=ltr] .actions > *:not(:last-child) {
  margin-right: 12px;
}

</style>